function showImage(colorValue, shadeValue, printValue, stateValue, door_val) {
	const items = document.querySelectorAll(".media-viewer__item");

	if (printValue != "State Flag") {
		stateValue = "";
	}

	if (printValue.includes("Blue USA Flag")) {
		colorValue = "";
	}

	function test_demo(itemdemo) {
		// console.log("itemdemo",itemdemo);
		setTimeout(() => {
			document.querySelectorAll(".media-viewer__item").forEach(el => el.style.display = "none");
			itemdemo.style.display = "block";
		}, 50);
	}

	items.forEach(item => {
		const img = item.querySelector("img");
		if (!img) {
			item.style.display = "none";
			return;
		}

		const altText = img.alt.toLowerCase();
		const shadeMatch = !shadeValue || altText.includes(shadeValue.toLowerCase());
		const printMatch = !printValue || normalizeString(altText).includes(normalizeString(printValue));
		const colorMatch = !colorValue || altText.endsWith(`_${colorValue.toLowerCase()}`);
		const stateMatch = stateValue && altText.includes(stateValue.toLowerCase());
		const door_input = !door_val || altText.includes(door_val.toLowerCase());

			if ((shadeMatch && printMatch && colorMatch && door_input) ) {
				item.style.display = "block";
			} else {
				item.style.display = "none";
			}

			if (stateMatch && door_input) {
				test_demo(item);
				// console.log("demo_test");
				return true;
			}
		// if(door_input && stateMatch) {
		// 	console.log("door_val",door_val,"stateValue",stateValue);
		// 	item.style.display = "block";
		// }else {
		// 	item.style.display = "none";
		// }

		// if (altText.includes(door_val.toLowerCase()) && stateMatch) {
		// 	console.log("door_val",altText.includes(door_val.toLowerCase()) ,"stateMatch",stateMatch);
		// 	console.log("item",item);
		// 	item.style.display = "block";
		// }
		
	});

	// Show first image if nothing matches
	const anyVisible = Array.from(items).some(item => item.style.display === "block");
	if (!anyVisible) {
		const first = document.querySelector(".media-viewer__item:first-child");
		if (first) first.style.display = "block";
	}
}

function normalizeString(str) {
    return str
        .toLowerCase()
        .normalize("NFKD")
        .replace(/[\p{P}\p{S}]/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
}

window.addEventListener("HulkEvents", () => {
	const polling = setInterval(() => {
		const swatchList = document.querySelectorAll(
			// ".hulkapps_option.swatch_render div[aria-label='Color'] + div .hulkapps_swatch_option",
			".hulkapps_option.swatch_render div[aria-label='Background Color'] + div .hulkapps_swatch_option"
		);

		// if (!swatchList.length) return;

		// clearInterval(polling);

		const shadeInput = document.querySelector(
			".hulkapps_option.dd_render > div[aria-label='Shade Coverage'] + div select"
		);
		const printInput = document.querySelector(
			".hulkapps_option.dd_render > div[aria-label='Print'] + div select"
		);
		const stateInput = document.querySelector(
			".hulkapps_option.dd_render > div[aria-label='State'] + div select"
		);
		const doorsInput = document.querySelector(
			".hulkapps_option.dd_render > div[aria-label='Doors'] + div select"
		);

		// Helper to get currently selected color swatch
		const getSelectedColor = () => {
			for (const swatch of swatchList) {
				const selected = swatch.querySelector("div.swatch_selected");
				if (selected) return selected.getAttribute("value");
			}
			return null;
		};

		// Unified handler for any input change
		const updateImage = () => {
			const colorValue = getSelectedColor();
			var shadeValue = ""

			function cleanShade(value) {
				// Remove everything from "[" to "]"
				return value.replace(/\s*\[.*?\]\s*/g, "").trim()
				// Remove "(+ $xx.xx)" if it appears
				.replace(/\s*\(\+\$.*?\)\s*/g, "").trim();
			}

			if (shadeInput){
				// const shadeMatch = shadeInput.value.match(/\b(?:Full|Half)-Shade|2-Piece\b/);
				//const shadeMatch = shadeInput.value.match(/\b(?:FextractShade(shadeInput.value)ull|Half)-Shade(?:\s*\([^)]*\))?|\b2-Piece\b/);
				const shadeMatch = cleanShade(shadeInput.value);
				
				var shadeValue = cleanShade(shadeInput.value);
				console.log("shadeValue",shadeValue,"shadeMatch",shadeMatch);
			}

			const door_val = doorsInput?.value;
			const printValue = printInput?.value || "";
			const stateValue = stateInput?.value || "";		
			
				if (colorValue || stateValue || printValue) {
					showImage(colorValue, shadeValue, printValue, stateValue, door_val);
				}
			
		};

		// Attach events
		swatchList.forEach(swatch => {
			swatch?.addEventListener("click", updateImage);
		});
		if(shadeInput){
			shadeInput?.addEventListener("change", updateImage);
		}
		if(doorsInput){
			doorsInput?.addEventListener("change", updateImage);
		}
		printInput?.addEventListener("change", updateImage);
		stateInput?.addEventListener("change", updateImage);

		// Initial call
		updateImage();

	}, 100);

	setTimeout(() => clearInterval(polling), 20000);
});